<script>
export default {
  name: "copyright_footer"
}
</script>

<template>
  <div class="copyright_footer">
    <div class="container">
      <p class="text vendor">© 2016-2026 Kotlov City</p>
      <div class="container-developers">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/base";
.copyright_footer{
  width: 100%;
  background-color: $lggrey;
}

.container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $text_color;
  padding: 20px;
}

.container-developers{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.text{
  font-family: "Raleway", sans-serif;
  font-size: 14px;
  font-weight: normal;
}
</style>
